import React from "react";

const RoleJourneyModal = ({ roleData, onClose, onPhaseClick }) => {
  if (!roleData) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000,
      padding: '2rem'
    }} onClick={onClose}>
      
      <div style={{
        background: '#fff', borderRadius: '16px', overflow: 'hidden',
        width: '100%', maxWidth: '850px', maxHeight: '90vh',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', display: 'flex', flexDirection: 'column'
      }} onClick={e => e.stopPropagation()}>

        {/* Header - Fixed Contrast */}
        <div style={{ background: '#1e1b4b', padding: '2rem', color: 'white', borderBottom: "4px solid #7C3AED" }}>
          <div style={{ textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.8rem', opacity: 0.8, marginBottom: '0.5rem', fontWeight: "bold", color: 'white' }}>
            Curriculum Path
          </div>
          {/* ✅ FIXED: Explicitly set color to white here */}
          <h2 style={{ margin: 0, fontSize: '2.2rem', color: 'white' }}>{roleData.role}</h2>
          <p style={{ margin: '0.5rem 0 0', opacity: 0.9, fontSize: '1.1rem', fontStyle: 'italic', color: "#c7d2fe" }}>
            "{roleData.goal}"
          </p>
        </div>

        {/* Journey Map */}
        <div style={{ padding: '2rem', overflowY: 'auto', background: '#f8fafc' }}>
          
          {roleData.phases.map((phase, i) => (
            <div key={i} style={{ marginBottom: '2rem', display: 'flex', gap: '1.5rem' }}>
              {/* Timeline Graphic */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ 
                  width: '36px', height: '36px', borderRadius: '50%', 
                  background: i === 2 ? '#F59E0B' : '#7C3AED', 
                  color: 'white', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 10, fontSize: "1.1rem"
                }}>
                  {i + 1}
                </div>
                {i < 2 && <div style={{ width: '2px', flex: 1, background: '#e2e8f0', margin: '0.5rem 0' }}></div>}
              </div>

              {/* Phase Content Card */}
              <div style={{ flex: 1, background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                  <h3 style={{ margin: 0, color: '#1e293b', fontSize: '1.1rem' }}>{phase.name}</h3>
                  
                  {/* SharePoint Button */}
                  <button 
                    onClick={() => onPhaseClick(phase, roleData.role)}
                    style={{
                      background: "#f0f9ff", color: "#0284c7", border: "1px solid #bae6fd",
                      padding: "0.25rem 0.75rem", borderRadius: "99px", fontSize: "0.75rem",
                      fontWeight: "700", cursor: "pointer", display: "flex", alignItems: "center", gap: "0.25rem"
                    }}
                  >
                    Open Site ↗
                  </button>
                </div>

                <ul style={{ paddingLeft: '1.2rem', margin: 0, color: '#475569' }}>
                  {phase.items.map((item, j) => (
                    <li key={j} style={{ marginBottom: '0.5rem' }}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}

          {/* Action Footer */}
          <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
             <button onClick={onClose} style={{
                padding: '0.75rem 1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                background: 'white', color: '#64748b', cursor: 'pointer', fontWeight: '600'
             }}>
               Close Tour
             </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default RoleJourneyModal;
